import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle, X } from 'lucide-react';

const MaintenanceModal = () => {
  const { i18n } = useTranslation();
  const [data, setData]       = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch(`/infofluo/maintenance.json?v=${Date.now()}`)
      .then(r => { if (!r.ok) throw r; return r.json(); })
      .then(d => {
        if (!cancelled && d.enabled === true) {
          setData(d);
          setVisible(true);
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!visible || !data) return null;

  const lang       = (i18n.language || 'fr').slice(0, 2);
  const message    = data.message?.[lang]  ?? data.message?.fr  ?? '';
  const buttonText = data.button?.[lang]   ?? data.button?.fr   ?? 'OK';

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 px-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 sm:p-7">

        {/* Bouton × */}
        <button
          onClick={() => setVisible(false)}
          aria-label="Fermer"
          className="absolute top-4 right-4 text-slate-400 hover:text-slate-700 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Icône + message */}
        <div className="flex items-start gap-4 mb-6">
          <div className="w-10 h-10 rounded-full bg-ter-yellow/20 flex items-center justify-center shrink-0 mt-0.5">
            <AlertTriangle className="w-5 h-5 text-ter-yellow" />
          </div>
          <p className="text-sm text-slate-700 leading-relaxed pt-2">{message}</p>
        </div>

        {/* Bouton OK */}
        <button
          onClick={() => setVisible(false)}
          className="w-full h-10 rounded-lg bg-ter-blue text-white text-sm font-bold hover:brightness-95 transition"
        >
          {buttonText}
        </button>

      </div>
    </div>
  );
};

export default MaintenanceModal;
